
<template>
  <div class="contact">
    <div class="main-top">
      <img src="../assets/img/main-title.jpg" alt="" />
    </div>
    <div class="main-content">
      <div class="main-title">
        <h1>公司地址</h1>
      </div>
      <div class="main-summary">
        <p>地址：西安市雁塔区太白南路181号西部电子社区A座A区A107-V04室</p>
        <p>电话：029-81565335</p>
      </div>
      <div id="container" class="map"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      map: {},
    };
  },
  mounted() {
    this.mapInit();
  },
  methods: {
    mapInit() {
      var map = new AMap.Map("container", {
        resizeEnable: true,
        zoom: 18, //级别
        center: [108.911, 34.2143],
        viewMode: "2D",
      });
      var marker = new AMap.Marker({
        position: new AMap.LngLat(108.911, 34.2143), 
        title: "西安伟普通信技术有限公司",
        offset: new AMap.Pixel(-13, -30),
        clickable: true,
      });
      map.add(marker);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.contact {
  background-color: #f7f7f7;
  .main-top {
    margin: 1vh 0 0 0;
    height: 13vh;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .main-content {
    margin: 0 5vw;
    .main-title {
      border-bottom: 1px solid #ecedf1;
      overflow: hidden;
      height: 100px;
      h1 {
        background: url(../assets/img/red-line.png) no-repeat center bottom;
        font-weight: 700;
        width: 160px;
        line-height: 100px;
        margin: 0;
      }
    }
    .main-summary {
      p {
        text-indent: 28px;
        line-height: 36px;
        font-size: 16px;
      }
    }
    .map {
      height: 60vh;
      width: 100%;
      margin: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contact.vue